import { render } from "./CreateProductPurchaseExpenseModal.vue?vue&type=template&id=88ed9dc4&scoped=true"
import script from "./CreateProductPurchaseExpenseModal.vue?vue&type=script&lang=js"
export * from "./CreateProductPurchaseExpenseModal.vue?vue&type=script&lang=js"

import "./CreateProductPurchaseExpenseModal.vue?vue&type=style&index=0&id=88ed9dc4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ed9dc4"]])

export default __exports__